<template>
  <div class="login-form fullheight pos-relative">
    <div class="img-logo text-center">
      <img src="~@/assets/images/logo/kromnix-logo-main.png" alt="kromnix logo" width="100%" @click="handleRedirection('companies')" class="clickable">
    </div>
    <h3 class="text-center">{{ (logType == 1)? 'Welcome to the Buyer\'s space!':'Welcome Tech Provider!' }}</h3>
    <InfoMessages ref="InfoMessages" class="text-left"/>
    <Form ref="loginForm" :model="formData" :rules="formRules">
      <FormItem prop="email">
        <Input v-model="formData.email" placeholder="Email address or username" class="username" size="large"/>
      </FormItem>
      <FormItem prop="password">
        <Input type="password" v-model="formData.password" placeholder="Password" class="password" size="large"/>
      </FormItem>
      <FormItem>
        <div><Checkbox v-model="formData.remember_me" class="is-remember">Remember me</Checkbox></div>
        <div class="forgot-password">
          <Button type="text" class="no-padding" @click="handleLostPassword">
            Forgot password?
          </Button>
        </div>
        <Button class="login-btn" @click="handleSubmit('loginForm')" size="large" long :loading="isLoading">Log in</Button>
        <Divider plain class="_divider">or</Divider>
        <Button class="k-btn-4" @click="handleRedirection((logType == 1)?'buyer-signup':'tech-provider-signup')" size="large" long>Create an account</Button>
      </FormItem>
    </Form>
    <LostPasswordModal ref="LostPasswordModal" />
  </div>
</template>

<script>
import { techProviderLogin, buyerLogin, setAuthSession } from '@/services/auth'
import InfoMessages from '@/components/ui/InfoMessages'
import LostPasswordModal from '@/components/auth/LostPassword'

export default {
  props: {
    login_type: {
      type: String,
      default: 'Tech Provider'
    }
  },

  components: {
    InfoMessages,
    LostPasswordModal
  },

  data () {
    return {
      isLoading: false,
      formData: {
        email: null,
        password: null,
        remember_me: false
      },
      formRules: {
        email: [
          { required: true, message: 'Please fill in the username', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Please fill in the password.', trigger: 'blur' }
        ]
      },
      logType: localStorage.getItem('logType')
    }
  },

  mounted () {
    if (this.$route.name === 'tech-provider-login') {
      this.logType = 0
      localStorage.setItem('logType', 0)
    } else {
      this.logType = 1
      localStorage.setItem('logType', 1)
    }
  },

  methods: {
    handleBuyerLogin () {
      this.isLoading = true
      buyerLogin(this.formData).then(res => {
        if (res.data.message) {
          this.$refs.InfoMessages.showErrors(res)
          this.isLoading = false
        } else {
          setAuthSession(res.data)
          this.isLoading = false

          this.$Message.success({
            background: true,
            duration: 3,
            content: 'You are successfully logged in!'
          })
          window.location.href = process.env.VUE_APP_BASE_URL
        }
      }).catch(err => {
        console.log('Failed to login: ', err)
        this.$refs.InfoMessages.showErrors(err.response)
        this.isLoading = false
      })
    },
    handleTechProviderLogin () {
      this.isLoading = true
      techProviderLogin(this.formData).then(res => {
        if (res.data.message) {
          this.$refs.InfoMessages.showErrors(res)
          this.isLoading = false
        } else {
          setAuthSession(res.data)
          this.isLoading = false

          this.$Message.success({
            background: true,
            duration: 3,
            content: 'You are successfully logged in!'
          })
          window.location.href = process.env.VUE_APP_BASE_URL
        }
      }).catch(err => {
        console.log('Failed to login: ', err)
        this.$refs.InfoMessages.showErrors(err.response)
        this.isLoading = false
      })
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.logType === 1) {
            this.handleBuyerLogin()
          } else {
            this.handleTechProviderLogin()
          }
        } else {
          this.$Message.error('Please fill in all the required fields')
        }
      })
    },
    handleRedirection (val) {
      this.$router.push({
        name: val
      })
    },
    handleLostPassword () {
      this.$refs.LostPasswordModal.openModal()
    }
  }
}
</script>
<style lang="scss" scoped>
.login-form {
  text-align: center;
  width: 300px;
  margin: auto;
  .img-logo {
    width: 200px;
    margin: auto;
  }
  h3 {
    color: #000000;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .forgot-password {
    button {
      &:hover {
        background-color: transparent;
      }
      &:focus {
        box-shadow: none;
      }
    }
  }
  .login-btn {
    background: rgba(145,0,0,1);
    color: #ffffff;
    display: block;
    margin: 10px auto;
  }
}
</style>

<style lang="scss" >
.username {
  .ivu-input {
    width: 300px;
  }
}
.password {
  .ivu-input {
    width: 300px;
  }
}
._divider {
  line-height: 0px;
  margin: 25px 0 !important;
  &::before {
    border-top: 1px solid $secondary !important;
  }
  &::after {
    border-top: 1px solid $secondary !important;
  }
}
.is-remember {
  .ivu-checkbox {
    line-height: 1.5;
  }
}
</style>
